/**
 * Use this file to manage constants related to Redux state management
 */

/* -----------------    Action Identifiers     ------------------ */

export const ACTION_SET_AUTH_USER = 'AUTH_USER_SET';
export const ACTION_SET_UNITS = 'UNITS_SET';
export const ACTION_SET_UPDATE_UNIT = 'UNIT_UPDATE_SET';
export const ACTION_SET_SELECTED_UNIT = 'SELECTED_UNIT_SET';



// WEBPACK FOOTER //
// ./src/reducers/constants.js